import React from 'react';
import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, BarElement, CategoryScale, LinearScale, Tooltip, Legend } from 'chart.js';
import { Box } from '@mui/material';
ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend);

const PostsBarChart = ({ xLables }) => {
  const DATA_COUNT = 7;
  const NUMBER_CFG = { count: DATA_COUNT, min: 0, max: 100 };

  const Utils = {
    numbers: ({ count, min, max }) => Array.from({ length: count }, () => Math.floor(Math.random() * (max - min + 1)) + min),
    CHART_COLORS: {
      black: '#2f3035',
      blue: '#5985fe',
      green: '#2dd673'
    },
    transparentize: (color, opacity) => {
      const alpha = Math.round(opacity * 255);
      return `${color}${alpha?.toString(16)?.padStart(2, '0')}`;
    }
  };


  const keys = Object?.keys(xLables); // ["pendingCount", "publishCount", "totalCount", "trashCount"]
  const values = keys.map(key => parseInt(xLables[key]?.[0]?.count || 0)); // [0, 0, 7, 7] or default to 0

  const data = {
    labels: keys, // ["pendingCount", "publishCount", "totalCount", "trashCount"]
    datasets: [
      {
        label: 'Posts',
        data: values, // [0, 0, 7, 7]
        backgroundColor: [
          Utils.CHART_COLORS.black,
          Utils.CHART_COLORS.blue,
          Utils.CHART_COLORS.green,
          Utils.CHART_COLORS.red,
        ],
        borderColor: [
          Utils.CHART_COLORS.black,
          Utils.CHART_COLORS.blue,
          Utils.CHART_COLORS.green,
          Utils.CHART_COLORS.red,
        ],
        borderWidth: 2,
        borderRadius: Number.MAX_VALUE,
        barPercentage: 0.4
      }
    ]
  };



  const options = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      x: { beginAtZero: true },
      y: { beginAtZero: true }
    },
    // plugins: {
    //   legend: {
    //     position: 'bottom',
    //     labels: {

    //       boxWidth: 20, // Set the width of the legend box; this will be square by default
    //       padding: 26,
    //     }
    //   },
    //   // tooltip: {
    //   //   callbacks: {
    //   //     label: (context) => {
    //   //       const value = context.raw;
    //   //       const percentage = Math.round((value / Math.max(...bought)) * 100);
    //   //       return `${context.dataset.label}: ${value} (${percentage}%)`;
    //   //     }
    //   //   }
    //   // }
    // }
  };

  return (
    <div style={{ height: "70vh", width: "100%" }}>

      <Bar xLables={xLables} data={data} options={options} />
    </div>
  );
};

export default PostsBarChart;
